import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IMedia, SdBannerComponent } from '@seb/web-design-system/core';

@Component({
  selector: 'sd-product-logo',
  templateUrl: './product-logo.component.html',
  styleUrls: ['./product-logo.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdBannerComponent]
})
export class SdProductLogoComponent {
  DEFAULT_WIDTH = 46;
  @Input()
  media: IMedia;

  @Input()
  width: number = this.DEFAULT_WIDTH;

}
